import './App.css';
import PeriodicTable from './PeriodicTable';

function App() {
  return (
    <div className="App"> 
      <header>
  
      </header>
      <PeriodicTable />
     
    </div>
  );
}

export default App;